import * as React from 'react';
import { Suspense } from 'react';
import Box from '@mui/material/Box';
import { Typography } from '@mui/material';
import { Canvas } from '@react-three/fiber';
import { OrbitControls, Stars } from '@react-three/drei';
import { Model } from './Model2';
export default function BoxID003() {
    return (
        <Box>
            <Box  >
                <Box sx={{ position: 'relative', justifyContent: 'space-between ', display: 'flex', marginBottom: 3, }} >
                    <Typography sx={{ textTransform: 'uppercase', fontWeight: 600, fontSize: 15 }}>
                        Personal Model ThreeJS
                    </Typography>
                    <Typography sx={{ textTransform: 'uppercase', fontWeight: 600, fontSize: 15 }}>
                        ID: 003
                    </Typography>
                </Box>
                <Canvas camera={{ position: [2, 0, 12.25], fov: 10 }}
                    style={{
                        width: '100%',
                        height: '600px',
                        
                    }}>
                    <ambientLight intensity={1.25} />
                    <Stars />
                    <OrbitControls></OrbitControls>
                    <Suspense fallback={null}>
                        <Model position={[0.025, -0.9, 0]} />
                    </Suspense>
                </Canvas>
            </Box>


        </Box>
    )
}
